import { isMobile } from "react-device-detect";

import "./step-3.scss";
import { useState } from "react";

function Step3({ prevStep, register }) {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const terms = [
    {
      title: "CLÁUSULA 1 - OBJETO DO TERMO DE USO:",
      texts: [
        "1.1 Este contrato regula o serviço de locação fornecido pela ADOLETA para o CLIENTE, mediante pagamento do valor estipulado no momento da locação, sendo o valor variável para cada tipo de brinquedo locado. A prestação do serviço, objeto deste contrato, é restrito ao município que o CLIENTE informar na hora do contrato.",
        "1.2 A ADOLETA se reserva o direito de alterar qualquer condição deste TERMO DE USO ao seu exclusivo critério. Em caso de alteração no TERMO DE USO, o CLIENTE será imediatamente informado via e-mail ou WhatsApp. A continuidade da utilização do serviço contratado implicará na aceitação das alterações pelo CLIENTE.",
      ],
    },
    {
      title: "CLÁUSULA 2 – ALUGUEL DE BRINQUEDOS E ACESSÓRIOS:",
      texts: [
        "2.1 A locação do brinquedo/acessório será realizada através do site: www.adoletaalugueldebrinquedos.com.br, o CLIENTE poderá optar pela entrega do objeto contratado em seu domicílio – anteriormente informado, bem como poderá optar pela retirada deste no local informado pela empresa ADOLETA.",
        "2.1.1. Todas as entregas e /ou retiradas serão feitas mediante agendamento, conforme disponibilidade da contratada.",
        "2.1.2. O pagamento do aluguel será feito diretamente no endereço eletrônico da contratada, podendo o CLIENTE optar pela realização deste por meio do aplicativo Picpay, Pagseguro, por Transferência bancária ou Pix.",
        "2.2 O preço da locação irá variar de acordo com o tipo do brinquedo/acessório locado, e os valores poderão sofrer alterações – a qualquer tempo e sem que haja a necessidade de aviso prévio aos CLIENTES.",
        "2.3 Cada locação possui suas próprias condições de uso e todas estarão contidas no site junto à descrição de cada produto.",
        "2.3.1. As condições de uso irão incluir tarifas (quinzenal, mensal, bimestral, trimestral – em determinadas locações), período mínimo e máximo de cada locação, condições de entrega/coleta ou retirada/devolução, entre outros aspectos.",
        "2.4 A solicitação de locação do produto não obriga a ADOLETA a proceder com o serviço de maneira imediata, estando essa condicionada a uma análise cadastral do CLIENTE, visando atestar a veracidade dos dados fornecidos para sua própria segurança.",
        "2.5 Os dados cadastrais fornecidos pelo CLIENTE farão parte de um cadastro confidencial, com acesso restrito a ADOLETA.",
      ],
    },
    {
      title: "CLÁUSULA 3 – ENTREGA/COLETA:",
      texts: [
        "3.1 As entregas e coletas dos produtos locados só serão realizadas mediante presença de um responsável.",
        "3.2 Caso o responsável pelo recebimento e/ou devolução do produto locado não esteja presente no dia e horário agendados, a ADOLETA se compromete a tentar entrar em contato com o responsável, estipulando ainda um prazo de tolerância de até 10 minutos.",
        "3.3. Em caso de impossibilidade da entrega e/ou coleta, será cobrada uma taxa de R$ 15 (quinze reais) para realização de uma nova coleta, acrescendo-se a quantia correspondente a locação diária do produto por cada dia extra que o CLIENTE passar em posse deste.",
        "3.4. A aplicação das taxas não será cobrada, desde que o CLIENTE proceda com a entrega ou recolhimento do produto em local específico informado pela ADOLETA até o dia seguinte ao seu vencimento.",
      ],
    },
    {
      title: "CLÁUSULA 4 – TROCA DE BRINQUEDOS/ACESSÓRIOS:",
      texts: [
        "4.1 O CLIENTE poderá, ao seu critério, realizar uma troca de produto, nos primeiros 15 dias de locação, mediante pagamento de taxa no valor de R$ 30 (trinta reais), o pagamento da taxa deverá ser efetuado através de Transferência bancária ou Pix, antes da efetiva entrega do novo produto.",
        "4.1.1. O valor da taxa será reduzido para R$ 15 (quinze reais) quando o cliente efetuar a troca em local especificado pela ADOLETA.",
        "4.2 A troca só poderá ser realizada por produtos que – no momento da troca, estejam disponíveis para locação em nosso site.",
        "4.3 Caso o produto pretendido possua valor de locação superior ao que será trocado, o cliente pagará a diferença de valores, via Transferência bancária ou Pix, antes da efetivamente troca.",
        "4.4 Vindo o valor de locação do produto a ser inferior ao anteriormente locado, o CLIENTE não terá direito a estorno do valor. 4.5 O serviço de troca só pode ser realizado uma vez por mês e durante os primeiros 15 (quinze) dias de locação.",
      ],
    },
    {
      title: "CLÁUSULA 5 – RENOVAÇÃO DE BRINQUEDOS/ACESSÓRIOS:",
      texts: [
        "5.1 Antes do término da locação a ADOLETA se compromete a entrar em contato com o CLIENTE a fim de verificar se há interesse na renovação da locação, dando a esse direito de preferência em caso positivo.",
        "5.2 Vindo o CLIENTE a manifestar interesse na renovação, esse poderá efetuar o pagamento da renovação até o segundo dia corrido, após o vencimento da locação.",
        "5.3. Caso o pagamento não seja efetuado no prazo estabelecido, o CLIENTE deverá proceder com a taxa de coleta em domicílio, mediante pagamento da taxa constante na cláusula 3.3, com data e horário agendados ou entregue em local especificado pela ADOLETA.",
        "5.4. Serão cobradas ao CLIENTE as taxas diárias de locação de cada produto referente aos dias excedidos sem que haja sua efetiva renovação.",
      ],
    },
    {
      title: "CLÁUSULA 6 - DANOS E EXTRAVIOS:",
      texts: [
        "6.1 O CLIENTE ou RESPONSÁVEL deverá verificar o estado do brinquedo no ato da entrega/coleta e da retirada/devolução.",
        "6.2 O CLIENTE se responsabilizará por eventuais danos ocorridos aos produtos locados, no período em que estes estiverem em seu poder, comprometendo-se a repor as peças avariadas ou a anuir com o pagamento do conserto.",
        "6.3 Em caso de destruição, perda ou inutilização do produto, o CLIENTE se responsabilizará a pagar o seu valor de mercado, com desconto de até 20% do valor. O valor de mercado de cada produto é estipulado pela ADOLETA, com base nos preços atualizados das principais lojas de brinquedos.",
        "6.3.1. Caso o brinquedo ou acessório danificado ou perdido esteja fora de comercialização, o CLIENTE deverá anuir com o pagamento deste tomando por base o preço de um produto similar, que será estipulado pela ADOLETA.",
        "6.4 O pagamento constante nesta cláusula deverá ser realizado em até 10 (dez) dias corridos, a contar da data de devolução do produto e esse deverá ser realizado via Picpay, Transferência bancária ou Pix.",
      ],
    },
    {
      title: "CLÁUSULA 7 – CADASTRO DO CLIENTE:",
      texts: [
        "7.1 O CLIENTE se compromete a atualizar suas informações sempre que existirem mudanças e declara, para os devidos fins, que os dados informados no cadastro são verídicos em sua totalidade.",
        "7.2 Os dados cadastrais fornecidos pelos clientes para a ADOLETA não serão repassados para terceiros, salvo quando as informações forem necessárias para realização do processo de entrega, de cobrança ou para participação de promoções de interesse do CLIENTE. A ADOLETA se compromete em realizar a manutenção da privacidade e da segurança de seus CLIENTES.",
        "7.3 A ADOLETA se reserva ao direito de suspender ou cancelar os cadastros de clientes, nos seguintes casos:",
        "7.3.1 Vindo a ADOLETA a ser impossibilitada de cobrar quaisquer débitos junto ao CLIENTE.",
        "7.3.2 Seja detectado pela ADOLETA, a seu exclusivo critério, que o CLIENTE procedeu com um volume inaceitável de perdas, danos, ou extravios dos brinquedos, ou, ainda, em caso de possível fraude.",
      ],
    },
  ];

  return (
    <form
      className="form step-3"
      onSubmit={(e) => {
        e.preventDefault();
        register();
      }}
    >
      <div className="w-100 terms">
        {terms.map((term, index) => {
          return (
            <div key={index} className="paragraph">
              <p className="text title">
                <strong>{term.title}</strong>
              </p>
              {term.texts.map((text, index) => {
                return (
                  <p key={index} className="text">
                    {text}
                  </p>
                );
              })}
            </div>
          );
        })}
      </div>
      <div className="mt-5 form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="confirmarCheck"
          onChange={(e) => {
            setTermsAccepted(e.target.checked);
          }}
        />
        <label className="form-check-label" htmlFor="confirmarCheck">
          Concordo com os Termos de Uso acima citados e com nossa
          <strong> Política de Privacidade de Proteção de Dados.</strong>
        </label>
      </div>
      <div
        className={`w-100 mt-3 d-flex ${isMobile ? "flex-column mobile" : ""}`}
      >
        <button
          type="button"
          className="btn button-control button-prev"
          onClick={() => prevStep()}
        >
          Voltar
        </button>
        <button
          disabled={!termsAccepted}
          style={{ marginLeft: 20 }}
          type="submit"
          className="btn button-control button-next"
        >
          Aceitar e cadastrar
        </button>
      </div>
    </form>
  );
}

export default Step3;
